import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { House, ChartLineUp, Briefcase, SignOut, Crown, Sparkle } from "@phosphor-icons/react";

export default function Nav() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();

  const linkCls = (path) =>
    `flex items-center gap-2 px-3 py-2 text-sm font-medium border border-transparent hover:bg-black/5 ${loc.pathname === path ? "bg-ink text-paper" : ""}`;

  return (
    <header className="sticky top-0 z-40 bg-paper/95 backdrop-blur border-b border-black/10" data-testid="app-nav">
      <div className="max-w-[1400px] mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/dashboard" className="flex items-center gap-3 group" data-testid="nav-logo">
          <div className="w-8 h-8 bg-ikb text-paper grid place-items-center font-display font-bold">S</div>
          <div>
            <div className="font-display text-lg leading-none">StockProfit Life</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-ink2 mt-0.5">Understand · Track · Grow</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          <Link to="/dashboard" className={linkCls("/dashboard")} data-testid="nav-dashboard">
            <House weight="regular" size={16} /> Dashboard
          </Link>
          <Link to="/portfolio" className={linkCls("/portfolio")} data-testid="nav-portfolio">
            <Briefcase weight="regular" size={16} /> Portfolio
          </Link>
          <Link to="/explore" className={linkCls("/explore")} data-testid="nav-explore">
            <ChartLineUp weight="regular" size={16} /> Explore
          </Link>
          <Link to="/pricing" className={linkCls("/pricing")} data-testid="nav-pricing">
            <Crown weight="regular" size={16} /> Pricing
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          {user && !user.is_pro && (
            <Link to="/pricing" className="hidden sm:inline-flex items-center gap-1.5 px-3 py-2 bg-amber2 text-ink text-xs font-bold hover:bg-coral hover:text-paper transition-colors" data-testid="nav-upgrade">
              <Sparkle weight="fill" size={12} /> Upgrade
            </Link>
          )}
          {user?.is_pro && (
            <span className="hidden sm:inline-flex items-center gap-1 px-2 py-1 bg-ikb text-paper text-[10px] font-mono-num" data-testid="nav-pro-badge">
              <Crown weight="fill" size={10} /> PRO
            </span>
          )}
          {user && (
            <div className="hidden sm:flex items-center gap-2">
              {user.picture && <img src={user.picture} alt="" className="w-7 h-7 border border-black/10" />}
              <span className="text-sm font-medium">{user.name || user.email}</span>
            </div>
          )}
          <button
            onClick={() => { logout(); nav("/"); }}
            className="btn-ghost text-xs"
            data-testid="nav-logout"
          >
            <SignOut size={14} /> Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
